import { render, staticRenderFns } from "./ProductShowcasePage.vue?vue&type=template&id=4a839c28&scoped=true"
import script from "./ProductShowcasePage.vue?vue&type=script&lang=js"
export * from "./ProductShowcasePage.vue?vue&type=script&lang=js"
import style0 from "./ProductShowcasePage.vue?vue&type=style&index=0&id=4a839c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a839c28",
  null
  
)

export default component.exports